"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _EtudeUtils = require("./EtudeUtils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// for memo to recognize equality when a default no-op prop is needed
var NO_OP_KEY_ACTION = function NO_OP_KEY_ACTION() {};

function PianoKey(_ref) {
  var pitch = _ref.pitch,
      _ref$onKeyPress = _ref.onKeyPress,
      onKeyPress = _ref$onKeyPress === void 0 ? NO_OP_KEY_ACTION : _ref$onKeyPress,
      _ref$onKeyRelease = _ref.onKeyRelease,
      onKeyRelease = _ref$onKeyRelease === void 0 ? NO_OP_KEY_ACTION : _ref$onKeyRelease,
      _ref$isHighlight = _ref.isHighlight,
      isHighlight = _ref$isHighlight === void 0 ? false : _ref$isHighlight,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel;
  var isInvisible = pitch == null;
  var isInvisibleOrBlackKey = isInvisible || (0, _EtudeUtils.isBlackKey)(pitch);

  var button = /*#__PURE__*/_react["default"].createElement("button", {
    className: "".concat(isInvisibleOrBlackKey ? "black-key" : "white-key", " key ").concat(isHighlight ? "highlight-key" : ""),
    type: "button",
    onMouseDown: function onMouseDown(e) {
      return onKeyPress(pitch);
    },
    onMouseUp: function onMouseUp(e) {
      return onKeyRelease(pitch);
    },
    onMouseEnter: function onMouseEnter(e) {
      if (e.buttons & 1) onKeyPress(pitch);
    },
    onMouseLeave: function onMouseLeave(e) {
      if (e.buttons & 1) onKeyRelease(pitch);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "key-text"
  }, isInvisible || !showLabel ? "" : pitch.getKey().toString() + pitch.getOctave()));

  return isInvisibleOrBlackKey ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "black-key-container ".concat(isInvisible ? "invisible" : "")
  }, button) : button;
}

function areEqual(_ref2, _ref3) {
  var prevPitch = _ref2.pitch,
      prevOnKeyPress = _ref2.onKeyPress,
      prevOnKeyRelease = _ref2.onKeyRelease,
      prevIsHighlight = _ref2.isHighlight,
      prevShowLabel = _ref2.showLabel;
  var nextPitch = _ref3.pitch,
      nextOnKeyPress = _ref3.onKeyPress,
      nextOnKeyRelease = _ref3.onKeyRelease,
      nextIsHighlight = _ref3.isHighlight,
      nextShowLabel = _ref3.showLabel;
  if (prevPitch == null && nextPitch == null) {
    return true;
  }

  if (prevIsHighlight !== nextIsHighlight) {
    return false;
  }

  if (prevShowLabel !== nextShowLabel) {
    return false;
  }

  if (prevPitch.toString() !== nextPitch.toString()) {
    return false;
  }

  if (prevOnKeyPress !== nextOnKeyPress) {
    return false;
  }

  if (prevOnKeyRelease !== nextOnKeyRelease) {
    return false;
  }

  return true;
}

var _default = /*#__PURE__*/(0, _react.memo)(PianoKey, areEqual);

exports["default"] = _default;